import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledTextArea = styled.textarea`
  display: block;
  width: 100%;
  height: 200px;
  font-size: ${fonts.small};
  border: 1px solid ${colours.elexonBlue};
  border-radius: 12px;
  padding: 0.65rem 1rem;
  resize: none;

  &:focus,
  &:active,
  &:hover {
    outline: none;
    border: 1px solid ${colours.elexonBlue};
  }

  &.invalid {
    border: 1px solid ${colours.elexonRed};
  }
`;
